export const headerName = {
  add: "Добавить вид документа об обучении",
  edit: "Редактировать вид документа об обучении",
};
export const trainingDocTypesInputs = {
  name: {
    key: "name",
    label: "Наименование документа об образовании",
    type: "text",
    required: true,
  },
};
export const getTrainingDocTypesInputs = () => trainingDocTypesInputs;
